import {notyf} from "../../app/helpers";

document.addEventListener('DOMContentLoaded', function () {
    const inputs = document.querySelectorAll('.promo-code input[type="text"]');
    if (inputs.length) {
        inputs.forEach((input, index) => {
            input.addEventListener('input', (event) => {
                if (input.value.length === input.maxLength) {
                    const nextInput = inputs[index + 1];
                    if (nextInput) {
                        nextInput.focus();
                    }
                }
            });

            input.addEventListener('keydown', (event) => {
                if (event.key === 'Backspace' && input.value.length === 0) {
                    const prevInput = inputs[index - 1];
                    if (prevInput) {
                        prevInput.focus();
                    }
                }
            });
        });
    }

});

document.addEventListener("DOMContentLoaded", function () {
    const form = document.querySelector(".promo-code-form");
    if (form) {
        const inputs = form.querySelectorAll("input[name='code[]']");
        const submitButton = form.querySelector(".js--promo-code-submit");
        const errorSpan = form.querySelector('.error');
        const errorMessages = {
            ru: {
                promo: 'Некорректно введен промо код',
            },
            ua: {
                promo: 'Некоректно введено промо код',
            },
        };
        const bodyClass = document.body.classList.contains('ru') ? 'ru' : 'ua';
        const lang = errorMessages[bodyClass];


        function validateFields() {
            let isValid = true;
            if (inputs.length) {
                inputs.forEach(input => {
                    const value = input.value.trim();
                    if (!/^[0-9]{4}$/.test(value)) {
                        input.classList.add("invalid");
                        isValid = false;
                        errorSpan.style.display = 'block';
                        errorSpan.innerHTML = lang.promo;
                    } else {
                        input.classList.remove("invalid");
                        errorSpan.style.display = 'none';
                    }
                });
            }


            submitButton.disabled = !isValid;
            return isValid;
        }

        inputs.forEach(input => {
            input.addEventListener("input", validateFields);
        });

        form.addEventListener("submit", function (event) {
            event.preventDefault();

            if (!validateFields()) {
                return;
            }

            const formData = new FormData(form);
            const actionUrl = form.getAttribute("action");
            formData.append('_csrf', document.querySelector('meta[name="csrf-token"]').getAttribute('content'));

            fetch(actionUrl, {
                method: "POST",
                body: formData,
            })
                .then(response => response.json())
                .then(data => {
                    let success = data.success ?? false;
                    let notyfType = success ? 'success' : 'error';

                    if (data.message) {
                        notyf[notyfType](data.message).on('dismiss', ({target, event}) => {
                            if (data.url) {
                                window.location.href = data.url;
                            }
                        });
                    }
                    if (success) {
                        form.reset();
                    }
                })
                .catch(error => {
                    console.error("Error:", error);
                });
        });
    }
});

